import {takeLatestF, putAll, showSuccess} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {showBeError} from 'utils/show-be-error';

import {matingAction, ConfirmCreateCriteriaListAction} from '../action';
import {getCriteriaListVersion} from './get-criteria-list-version';

const te = t('mating');

function* execute(action: ConfirmCreateCriteriaListAction): SagaIterator {
    const {bookmark, criteria, criteriaListId, gridUserSettings, associationType} = action.payload;

    const version = yield* call(getCriteriaListVersion, criteriaListId);

    yield* put(matingAction.setLoading('confirmCriteriaListNameInProgress', true));

    const response = yield* call(Api.updateCriteriaList, {criteria, version, gridUserSettings}, {criteriaListId});

    const title = te('saveCriteriaList');

    if (response.isSuccess) {
        yield* put(matingAction.getCriteriaLists(bookmark, associationType, true));
        yield* put(showSuccess(title, te('criteriaListSaved')));
    } else {
        yield putAll(showBeError(response, title));
    }
    yield* put(matingAction.toggleOverwriteCriteriaListVisibility(bookmark, gridUserSettings));
    yield* put(matingAction.setLoading('confirmCriteriaListNameInProgress', false));
}

/** Saga that handles `mating/CONFIRM_CRITERIA_LIST`. */
export function* confirmCriteriaListSaga(): SagaIterator {
    yield takeLatestF('mating/CONFIRM_CRITERIA_LIST', execute);
}
